import React, { useState, useEffect } from 'react'
import {
  keepTextContent,
  sanitizeHtmlWithFilter,
} from '@chegg-wt/core/utils/contentFilters'
import { formatFootnotePreview } from '@chegg-wt/core/utils/previewCitation'
import { Clipboard } from '@chegg-wt/core/utils/clipboardPolyfill'
import * as Styled from './styled'
import { PREMIUM_COPY_MODAL_FOOTNOTE_CONTAINER_ID } from './testIds'

interface Props {
  footnote: string
}

export const FootnoteModal: React.FC<Props> = ({ footnote }) => {
  // state
  const [locator, setLocator] = useState('')
  const [footnotePreview, setFootnotePreview] = useState(footnote || '')
  const [copied, setCopied] = useState(false)

  const handleCopy = (html) => {
    Clipboard.copy({
      'text/plain': keepTextContent(html),
      'text/html': sanitizeHtmlWithFilter(html),
    })
    setCopied(true)
  }

  const handleLocatorChange = () => {
    if (locator) {
      const preview = formatFootnotePreview({ footnote, locator })
      setFootnotePreview(preview)
      return
    }
    setFootnotePreview(footnote)
  }

  useEffect(handleLocatorChange, [locator, footnote])

  return (
    <div data-test={PREMIUM_COPY_MODAL_FOOTNOTE_CONTAINER_ID}>
      <Styled.FormContainer>
        <Styled.InputContainer>
          <Styled.TextField>
            <Styled.SubHeader>Locator</Styled.SubHeader>
            <Styled.Input
              type="text"
              data-test="footnote-locator-input"
              placeholder="e.g. Page Number"
              value={locator}
              onChange={(e) => setLocator(e.target.value)}
            />
          </Styled.TextField>
        </Styled.InputContainer>
      </Styled.FormContainer>
      <Styled.PreviewContainer>
        <Styled.SubHeader>Preview</Styled.SubHeader>
        <Styled.PreviewContent>
          <div
            dangerouslySetInnerHTML={{ __html: sanitizeHtmlWithFilter(footnotePreview) }}
            data-test="preview-box"
          />
          <Styled.Button
            onClick={() => handleCopy(footnotePreview)}
            data-test="preview-copy-btn"
          >
            {copied ? 'Copied' : 'Copy'}
          </Styled.Button>
        </Styled.PreviewContent>
      </Styled.PreviewContainer>
    </div>
  )
}
